angular.module('pe4h').controller('Requests', function($scope, $state, $http, configuration, $interval) {
  $scope.getRequests = function() {
    $http({
      url: configuration.webApi.users.requests,
      method: "GET",
      data: {},
    }).success(function(res, status, headers, config) {
      $scope.requestsAll = res;
      $scope.requests = res;
      $scope.paging.total = $scope.requestsAll.length;
      $scope.createPaginationList();
      addRemainingTime();
    }).error(function(error, status, headers, config) {
      $scope.alertErrorFromServer(error);
    });
  };

  $scope.generateSeoUrlForRequest = function(request) {
    var seoTitle = "contract " + request.Label + " job in "+ request.City;
    return seoTitle.toLowerCase().replace(/ /g, "-");
  }

  $scope.getAllRequests = function() {
    $http({
      url: configuration.webApi.users.wrequests,
      method: "GET",
      data: {},
    }).success(function(res, status, headers, config) {
      $scope.requestsAll = res;
      $scope.requests = res;
      $scope.paging.total = $scope.requestsAll.length;
      $scope.createPaginationList();
      addRemainingTime();
    }).error(function(error, status, headers, config) {
      $scope.alertErrorFromServer(error);
    });
  };

  $scope.$watch('paging.mode', function(newValue, oldValue) {
    $scope.createPaginationList();
  });

  $scope.$watch('target.mode', function(newValue, oldValue) {
    if(newValue){
      var url =configuration.webApi.users.requests;
    }else{
      var url =configuration.webApi.users.wrequests;
    }
    $scope.updateRequestTarget(url);
  });

  $scope.updateRequestTarget = function(url){

    $http({
      url: url,
      method: "GET",
      data: {},
    }).success(function(res, status, headers, config) {
      $scope.requestsAll = res;
      $scope.requests = res;
      $scope.paging.total = $scope.requestsAll.length;
      $scope.createPaginationList();
      addRemainingTime();
    }).error(function(error, status, headers, config) {
      $scope.alertErrorFromServer(error);
    });

  }

  $scope.$watch('color.name', function(value) {

 });

  $scope.createPaginationList = function() {
    var pageCount = Math.ceil($scope.paging.total / $scope.paging.mode);
    $scope.requestsPaginated = [];
    $scope.requests = [];
    for (var i = 0; i < pageCount; i++) {
      var values = $scope.requestsAll.slice($scope.paging.mode * i, $scope.paging.mode * i + $scope.paging.mode);
      $scope.requestsPaginated[i] = values;
    };
    $scope.goToPage(1);
  };

  $scope.goToPage = function(page) {
    $scope.paging.current = page;
    if (1 <= page && page <= $scope.requestsPaginated.length) {
      $scope.requests = $scope.requestsPaginated[page - 1];
    }
    $scope.goToTop();
  };

  var getRemainingTime = function(time) {
    var now = moment();
    time = moment(time);
    var diffTime = time.diff(now);
    var duration = moment.duration(diffTime);
    var days = time.diff(now, 'days'),
      hrs = duration.hours(),
      mins = duration.minutes();
    return {
      days: days,
      hrs: hrs,
      mins: mins
    }
  }

  var addRemainingTime = function() {
    for (i in $scope.requestsAll)
      $scope.requestsAll[i].timeLeft = getRemainingTime($scope.requestsAll[i].ClosingDate);
  };

  var clockInterval = $interval(function() {
    addRemainingTime();
  }, 10000);

  // Very important to destroy interval, otherwise we end up stacking intervals
  $scope.$on('$destroy', function() {
    $interval.cancel(clockInterval);
  })

  $scope.isEmptyRequestList = function() {
    return $scope.requests.length == 0;
  };

  $scope.ignoreProject = function(index) {
    $http({
      url: configuration.webApi.projects.hide({
        id: $scope.requests[index].Id
      }),
      method: "PATCH",
      data: {},
    }).success(function(res, status, headers, config) {
      console.log("requests ignore", res);
      if($scope.target.mode == true){
        $scope.getRequests();
      }else{
        $scope.getAllRequests();
      }
      
    }).error(function(error, status, headers, config) {
      $scope.alertErrorFromServer(error);
      //authFactory.logout();
    });
  };


  function init() {

    $scope.first = $state.params.first;
    $scope.requests = [];
    // Paging
    $scope.paging = {};
    $scope.paging.values = [25, 100, Number.MAX_SAFE_INTEGER];
    $scope.paging.display = ["25", "100", "All"];
    $scope.paging.mode = $scope.paging.values[0];
    $scope.paging.current = 1;

    $scope.target = {};
    $scope.target.values = [true,false];
    $scope.target.display = ["For Me", "All"];
    $scope.target.mode = $scope.target.values[0];
    $scope.target.current = 1;



    $scope.getRequests();
  }

  init();
});
